import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Container, Typography, Box, Button, Chip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getBlogPostByIdentifier } from '../data/blogs';
import TrainTheMindArticle from '../components/views/BlogArticles/TrainTheMindArticle';
import './BlogPost.scss';

const ARTICLES = {
  'train-the-mind': TrainTheMindArticle,
};

const BlogPost = () => {
  const { slug } = useParams();
  const meta = getBlogPostByIdentifier(slug);
  const ArticleBody = meta ? ARTICLES[meta.slug] : null;

  useEffect(() => {
    if (meta?.title) {
      document.title = `${meta.title} | Venkat Sujit Adabala`;
    } else {
      document.title = 'Venkat Sujit Adabala - Portfolio';
    }
    return () => {
      document.title = 'Venkat Sujit Adabala - Portfolio';
    };
  }, [meta?.title]);

  if (!meta || !ArticleBody) {
    return (
      <div className="blog-page">
        <Container maxWidth="md" className="blog-container">
          <Typography variant="h5" gutterBottom>
            Article not found
          </Typography>
          <Button component={Link} to="/" startIcon={<ArrowBackIcon />}>
            Back to portfolio
          </Button>
        </Container>
      </div>
    );
  }

  return (
    <div className="blog-page">
      <Container maxWidth="md" className="blog-container">
        <Box className="blog-page-header">
          <Typography variant="h2" className="blog-page-heading" component="h1">
            Blogs
          </Typography>
          <Box className="blog-page-heading-divider" />
        </Box>

        <Box className="blog-hero">
          <Box className="blog-hero-tags">
            {meta.tags.map((tag) => (
              <Chip key={tag} label={tag} size="small" className="blog-hero-chip" />
            ))}
          </Box>
          {meta.hero ? (
            <>
              <Typography variant="h1" className="blog-hero-title blog-hero-title-split">
                {meta.hero.titleLine1}
                <br />
                <em>{meta.hero.titleLine2Italic}</em>
              </Typography>
              <Typography variant="body1" className="blog-hero-subtitle">
                {meta.hero.subtitle}
              </Typography>
              <Typography variant="body2" className="blog-hero-meta">
                {meta.hero.metaLine}
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="h1" className="blog-hero-title">
                {meta.title}
              </Typography>
              <Typography variant="body2" className="blog-hero-meta">
                {meta.readTime} · For software engineers
              </Typography>
            </>
          )}
        </Box>

        <article className="blog-article">
          <ArticleBody />
        </article>
      </Container>
    </div>
  );
};

export default BlogPost;
